module.exports = __webpack_public_path__ + "static/img/org_title3.b9631a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title3.png
// module id = EB5n
// module chunks = 4